var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xl",class:{ 'filter-active': _vm.infoOpen }},[_c('Projects'),_c('Title'),_c('HeroText'),_c('div',{staticClass:"backdrop fixed left-0 top-0 w-screen h-screen z-20 pointer-events-none"}),_c('Info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }